import concrete from '../assets/resources/concrete.png';
import metal from '../assets/resources/metal.png';
import plastic from '../assets/resources/plastic.png';
import fuel from '../assets/resources/fuel.png';
import worker from '../assets/resources/worker.png';
import money from '../assets/resources/money.png'
import energy from '../assets/resources/energy.png'

import p1 from '../assets/planets/1.png';
import p2 from '../assets/planets/2.png';
import p3 from '../assets/planets/3.png';
import p4 from '../assets/planets/4.png';
import p5 from '../assets/planets/5.png';
import p6 from '../assets/planets/6.png';
import p7 from '../assets/planets/7.png';
import p8 from '../assets/planets/8.png';
import p9 from '../assets/planets/9.png';
import p10 from '../assets/planets/10.png';
import p11 from '../assets/planets/11.png';
import p12 from '../assets/planets/12.png';
import p13 from '../assets/planets/13.png';
import p14 from '../assets/planets/14.png';
import p15 from '../assets/planets/15.png';
import p16 from '../assets/planets/16.png';
import p17 from '../assets/planets/17.png';
import p18 from '../assets/planets/18.png';
import p19 from '../assets/planets/19.png';
import p20 from '../assets/planets/20.png';

import astronomy from '../assets/tech/astronomy.png'
import body from '../assets/tech/body.png'
import combustion from '../assets/tech/combustion.png'
import ion from '../assets/tech/ion.png'
import beam from '../assets/tech/beam.png'
import projectile from '../assets/tech/projectile.png'
import armor from '../assets/tech/armor.png'
import storage from '../assets/tech/storage.png'
import colo from '../assets/tech/colo.png'

import fuel_ok from '../assets/fuel_ok.png'
import fuel_maybe from '../assets/fuel_maybe.png'
import fuel_no from '../assets/fuel_no.png'

import edit from '../assets/edit.png'
import ship from '../assets/ship.png'

import research_lab from '../assets/pages/research_lab.jpg'
import menu_background from '../assets/pages/menu-top.png'
import galaxy_background from '../assets/pages/galaxy_background.png'

import building_central from '../assets/buildings/central.png'
import building_housing from '../assets/buildings/housing.png'
import building_solar from '../assets/buildings/solar.png'
import building_concrete from '../assets/buildings/concrete.png'
import building_metal from '../assets/buildings/metal.png'
import building_plastic from '../assets/buildings/plastic.png'
import building_fuel from '../assets/buildings/fuel.png'
import building_storage from '../assets/buildings/storage.png'
import building_space_port from '../assets/buildings/space_port.png'
import building_lab from '../assets/buildings/lab.png'
import building_ship_factory from '../assets/buildings/ship_factory.png'

// ------------------------------------------------------------------------------------
// Icon mapping

export const RESOURCES = {
    concrete: concrete,
    metal: metal,
    plastic: plastic,
    fuel: fuel,
    worker: worker,
    money: money,
    energy: energy,
};

export const PLANETS = {
    p1: p1,
    p2: p2,
    p3: p3,
    p4: p4,
    p5: p5,
    p6: p6,
    p7: p7,
    p8: p8,
    p9: p9,
    p10: p10,
    p11: p11,
    p12: p12,
    p13: p13,
    p14: p14,
    p15: p15,
    p16: p16,
    p17: p17,
    p18: p18,
    p19: p19,
    p20: p20,
};

export const TECHNOLOGIES = {
    astronomy: astronomy,
    body: body,
    combustion: combustion,
    ion: ion,
    projectile: projectile,
    beam: beam,
    armor: armor,
    storage: storage,
    colo: colo,
};

export const OTHER = {
    edit: edit,
    ship: ship,
}

export const FUEL_STATES = {
    ok: fuel_ok,
    maybe: fuel_maybe,
    no: fuel_no,
};

export const PAGES = {
    research_lab: research_lab,
    menu_background: menu_background,
    galaxy_background: galaxy_background,
}

export const BUILDINGS = {
    central: building_central,
    housing: building_housing,
    solar: building_solar,
    concrete: building_concrete,
    metal: building_metal,
    plastic: building_plastic,
    fuel: building_fuel,
    storage: building_storage,
    space_port: building_space_port,
    lab: building_lab,
    ship_factory: building_ship_factory,
}